import { actions }  from "../../actions/common/markets";

export default function markets ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case actions.SET_MARKETS:
            return setMarkets( newState, action.markets );
        default: return newState;
    }
}

function setMarkets ( newState, markets ) {
    newState.markets = markets;

    return newState;
}


// WEBPACK FOOTER //
// src/client/reducers/common/markets.js